export const DEFAULT_EMI_THRESHOLD = 50000;
export const DEFAULT_EMI_TENURE = 12;
export const DEFAULT_EMI_TENURES = [3, 6, 9, 12];

/**
 * Determines whether an artwork is eligible for No Cost EMI display based on price threshold.
 */
export function isEmiEligible(
  price?: number | null,
  threshold: number = DEFAULT_EMI_THRESHOLD,
): boolean {
  if (typeof price !== "number" || isNaN(price) || price <= 0) {
    return false;
  }
  return price >= threshold;
}

/**
 * Calculates the rounded monthly installment for a given total price and tenure.
 */
export function calculateMonthlyInstallment(
  price?: number | null,
  tenure: number = DEFAULT_EMI_TENURE,
): number {
  if (typeof price !== "number" || isNaN(price) || price <= 0 || tenure <= 0) {
    return 0;
  }
  return Math.round(price / tenure);
}

/**
 * Formats a numeric price into the Indian numbering system (e.g. 1,91,667 or 23,00,000).
 */
export function formatPriceNumber(amount?: number | null): string {
  if (typeof amount !== "number" || isNaN(amount)) {
    return "0";
  }
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  }).format(amount);
}